import ProductUpdatePage from "./ProductUpdatePage";

export default ProductUpdatePage;
